import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      
      if (response.data.success) {
        localStorage.setItem('admin_token', response.data.token);
        toast.success('Connexion réussie !');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'var(--bg-secondary)'
    }}>
      <div style={{
        maxWidth: '400px',
        width: '100%',
        padding: '40px',
        background: 'var(--bg-primary)',
        border: '1px solid var(--border-light)',
        borderRadius: '0px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Lock size={48} color="#C9A961" style={{ marginBottom: '16px' }} />
          <h1 className="heading-1" style={{ marginBottom: '8px' }}>Administration</h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
            Nina Care Institut
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '24px' }}>
            <label htmlFor="password" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
              Mot de passe
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Entrez votre mot de passe"
              style={{
                width: '100%',
                padding: '16px',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px',
                fontSize: '14px'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary"
            style={{ width: '100%', background: '#C9A961', color: 'var(--bg-primary)', borderColor: '#C9A961' }}
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
